import { render, staticRenderFns } from "./format-form.vue?vue&type=template&id=7825bf95&scoped=true"
import script from "./format-form.vue?vue&type=script&lang=js"
export * from "./format-form.vue?vue&type=script&lang=js"
import style0 from "./format-form.vue?vue&type=style&index=0&id=7825bf95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7825bf95",
  null
  
)

export default component.exports